import { apiClient } from "./client";

export type Skill = {
  id: string;
  tenant_id: string;
  code: string;
  label: string;
  color: string | null;
  is_active: boolean;
};

export type SkillCreatePayload = {
  code: string;
  label: string;
  color?: string | null;
  is_active?: boolean;
};

export type SkillPatchPayload = Partial<Pick<Skill, "label" | "color" | "is_active">>;

export async function listSkills(activeOnly = true): Promise<Skill[]> {
  const { data } = await apiClient.get<Skill[]>("/api/v1/skills", {
    params: { active_only: activeOnly },
  });
  return data;
}

export async function createSkill(p: SkillCreatePayload): Promise<Skill> {
  const { data } = await apiClient.post<Skill>("/api/v1/skills", p);
  return data;
}

export async function patchSkill(id: string, p: SkillPatchPayload): Promise<Skill> {
  const { data } = await apiClient.patch<Skill>(`/api/v1/skills/${id}`, p);
  return data;
}

export async function deleteSkill(id: string): Promise<void> {
  await apiClient.delete(`/api/v1/skills/${id}`);
}

export async function listPractitionerSkills(practitionerId: string): Promise<Skill[]> {
  const { data } = await apiClient.get<Skill[]>(
    `/api/v1/practitioners/${practitionerId}/skills`,
  );
  return data;
}

export async function setPractitionerSkills(
  practitionerId: string,
  skillIds: string[],
): Promise<Skill[]> {
  const { data } = await apiClient.put<Skill[]>(
    `/api/v1/practitioners/${practitionerId}/skills`,
    { skill_ids: skillIds },
  );
  return data;
}

export async function listSlotRequiredSkills(slotTemplateId: string): Promise<Skill[]> {
  const { data } = await apiClient.get<Skill[]>(
    `/api/v1/slot-templates/${slotTemplateId}/required-skills`,
  );
  return data;
}

export async function setSlotRequiredSkills(
  slotTemplateId: string,
  skillIds: string[],
): Promise<Skill[]> {
  const { data } = await apiClient.put<Skill[]>(
    `/api/v1/slot-templates/${slotTemplateId}/required-skills`,
    { skill_ids: skillIds },
  );
  return data;
}


export type SkillStat = {
  skill_id: string;
  code: string;
  label: string;
  color: string | null;
  practitioner_count: number;
  org_active_total: number;
  coverage_ratio: number;
  slot_templates_requiring: number;
};

export type SkillStatsResponse = {
  organization_id: string | null;
  items: SkillStat[];
};

export async function getSkillStats(organizationId?: string): Promise<SkillStatsResponse> {
  const { data } = await apiClient.get<SkillStatsResponse>("/api/v1/skills/stats", {
    params: organizationId ? { organization_id: organizationId } : {},
  });
  return data;
}
